var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClearFilters = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.194 3.74a.665.665 0 0 0-.527-1.074H4.554l5.313 5.313 3.327-4.24zM1.873 1.873l-.946.94 5.74 5.853v4c0 .367.3.667.666.667h1.334c.366 0 .666-.3.666-.667V11.22l3.854 3.853.94-.94L1.873 1.873z"
})));
export default SvgClearFilters;